module.exports = __webpack_public_path__ + "img/tms.bf245fc3.png";